<template>
  <div class="checkWaybillDetail">
    <van-form label-width="120px">
      <van-field
        v-model="content.PWB_Number"
        :label="$t.checkWaybill.mainWbNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.PWB_Number)"
            v-if="content.PWB_Number"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="content.WB_Number"
        :label="$t.checkWaybill.sideWbNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.WB_Number)"
            v-if="content.WB_Number"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="content.JobNumber"
        :label="$t.checkWaybill.jobNumber"
        label-class="number-label"
        readonly
        v-if="menuState == 2"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.JobNumber)"
            v-if="content.JobNumber"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="content.order_customerinvoicecode"
        :label="$t.checkWaybill.temuOrderNumber"
        type="textarea"
        rows="2"
        readonly
        v-if="menuState == 1"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="gotoTms(content.HOId)"
            v-if="content.order_customerinvoicecode"
            >{{ $t.meta.detail }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="content.DeliveryCompanyName"
        :label="$t.checkWaybill.deliveryCustomer"
        readonly
      />
      <van-field
        v-model="content.DeliveryPhone"
        :label="$t.checkWaybill.deliveryPhone"
        readonly
      />
      <van-field
        v-model="content.ReceiveCompanyName"
        :label="$t.checkWaybill.receiveCustomer"
        readonly
      />
      <van-field
        v-model="content.ReceivePhone"
        :label="$t.checkWaybill.receivePhone"
        readonly
      />
      <van-field
        v-model="content.CreateTime"
        :label="$t.checkWaybill.createTime"
        readonly
      />
      <van-field
        v-model="content.GoodsDescribe"
        :label="$t.checkWaybill.goodsName"
        readonly
      />
      <van-field v-model="content.ReceiveCountryName" :label="$t.meta.country" readonly />
      <van-field v-model="content.AllWeight" :label="$t.checkWaybill.weight" readonly />
      <van-field
        v-model="content.AllBoxNumber"
        :label="$t.checkWaybill.pNumber"
        readonly
      />
      <van-field v-model="content.WB_TypeStr" :label="$t.checkWaybill.type" readonly />
      <van-field
        v-model="content.WarehouseName"
        :label="$t.checkWaybill.warehouse"
        readonly
      />
      <van-field
        v-model="content.StateName"
        :label="$t.checkWaybill.goodState"
        readonly
      />
      <van-field
        v-model="content.PaymentStateStr"
        :label="$t.checkWaybill.paymentStatus"
        readonly
      />

      <van-field
        :value="
          content.IsPreAlert == 1 ? $t.checkWaybill.added : $t.checkWaybill.notAdded
        "
        :label="$t.checkWaybill.preAlertTitle"
        readonly
      />

      <div class="multi-table" v-if="fileList">
        <van-field name="stepper" :label="$t.checkWaybill.mainNoButton">
          <template #input>
            <van-stepper :min="0" :value="fileList.length" :disabled="true" />
          </template>
        </van-field>
        <div v-for="(item, index) in fileList" :key="index">
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-image
                :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                width="50"
                height="50"
                fit="contain"
                style="vertical-align: top"
                v-if="item.FileAddress"
              ></van-image>
            </template>
          </van-field>
        </div>
      </div>
    </van-form>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <van-dialog
      :title="$t.checkWaybill.dialogSheetTitle"
      width="90%"
      v-model="showSheetDialog"
      @confirm="sheetConfirm"
      @cancel="sheetCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="sheet-alert">
          <van-radio-group v-model="dialogSheetForm.IsPrintVtrackLabel">
            <van-radio :name="0">{{ $t.checkWaybill.isPrintVtrackLabel1 }}</van-radio>
            <van-radio :name="1">{{ $t.checkWaybill.isPrintVtrackLabel2 }}</van-radio>
          </van-radio-group>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.checkWaybill.dialogSheetTitle"
      width="90%"
      v-model="showBillDialog"
      @confirm="billConfirm"
      @cancel="billCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="bill-alert">
          <van-form label-width="120px">
            <div class="warehouse-checkbox">
              <van-checkbox v-model="dialogBillForm.IsShowLogo">{{
                $t.checkWaybill.isLogo
              }}</van-checkbox>
              <van-checkbox v-model="dialogBillForm.IsShowName">{{
                $t.checkWaybill.isName
              }}</van-checkbox>
              <van-checkbox v-model="dialogBillForm.IsDraft">{{
                $t.checkWaybill.isDraft
              }}</van-checkbox>
              <van-checkbox v-model="dialogBillForm.IsTelexRelease">{{
                $t.checkWaybill.isTelexRelease
              }}</van-checkbox>
              <van-checkbox v-model="dialogBillForm.IsOriginal">{{
                $t.checkWaybill.isOriginal
              }}</van-checkbox>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.checkWaybill.dialogWarehouseTitle"
      width="90%"
      v-model="showWarehouseDialog"
      @confirm="waybillGoodsWarehousing"
      @cancel="warehouseCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
      className="warehouse-dialog"
    >
      <slot name="default">
        <div class="warehouse-alert">
          <van-form label-width="120px">
            <van-field
              v-model="dialogForm.warehouseNameOrNumber"
              :label="$t.checkWaybill.warehouseNameOrNumber"
              :placeholder="$t.meta.input"
            />

            <div class="warehouse-radio">
              <div class="radio-label">
                {{ $t.checkWaybill.warehouseOwnership }}
              </div>
              <van-radio-group
                v-model="dialogForm.WarehouseOwnership"
                direction="horizontal"
              >
                <van-radio :name="1">{{ $t.warehouse.ownerOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.warehouse.ownerOption2 }}</van-radio>
              </van-radio-group>
            </div>

            <van-field
              clickable
              readonly
              :value="dialogSearchForm.CountryName"
              :label="$t.meta.country"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showCheckWaybillDetailCountry')"
            />

            <van-field
              clickable
              readonly
              :value="dialogSearchForm.CityName"
              :label="$t.meta.city"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showCheckWaybillDetailCity')"
            />

            <div style="margin: 16px; text-align: center">
              <van-button
                type="info"
                style="width: 40%"
                size="small"
                @click="getWarehouseManagementList"
                >{{ $t.meta.search }}</van-button
              >
              <van-button
                type="default"
                style="width: 40%"
                size="small"
                @click="initWarehouse"
                >{{ $t.meta.reset }}</van-button
              >
            </div>

            <van-field
              v-model="dialogForm.WarehouseName"
              :label="$t.checkWaybill.warehouse"
              :placeholder="$t.meta.select"
              @click="showWarehousePicker = true"
              required
              clickable
              readonly
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <option-list
      event="showCheckWaybillDetailCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showCheckWaybillDetailCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-popup v-model="showWarehousePicker" round position="bottom">
      <van-picker
        :title="$t.checkWaybill.warehouseList"
        show-toolbar
        :columns="warehouseList"
        @confirm="pickerConfirm"
        :confirm-button-text="$t.meta.confirm"
        @cancel="pickerCancel"
        :cancel-button-text="$t.meta.cancel"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";

import {
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Image,
  ActionSheet,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper);

export default {
  name: "checkWaybillDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      UserName: JSON.parse(localStorage.getItem("auth")).userInfo.UserName,
      content: {},
      menuState: 1,
      fileList: [],
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //仓库
      showWarehouseDialog: false,
      showWarehousePicker: false,
      countryList: [],
      cityList: [],
      warehouseList: [],
      dialogSearchForm: {
        warehouseNameOrNumber: "",
        WarehouseOwnership: "",
        WarehouseState: 1,
        CountryId: null,
        CountryName: "",
        CityId: null,
        CityName: "",
        PageIndex: 0,
        PageSize: 999,
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      },
      dialogForm: {
        WB_Id: "", //运货单Id
        WHId: "", //	仓库Id
        WarehouseName: "", //仓库名称
      },
      //查看提单
      showBillDialog: false,
      dialogBillForm: {
        IsShowLogo: false,
        IsShowName: false,
        IsDraft: false,
        IsTelexRelease: false,
        IsOriginal: false,
      },
      //查看面单
      showSheetDialog: false,
      dialogSheetForm: {
        IsPrintVtrackLabel: 0,
      },
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("checkWaybillDetail"));
    this.content = data;
    this.$commonMethod.fieldRefresh(".checkWaybillDetail");
    this.menuState = this.content.MenuState;

    if (this.content.PWB_Number) this.getWayBillByPrimaryFileList();
  },
  methods: {
    sheetConfirm() {
      this.showSheetDialog = false;
      this.gotoPrint(2);
    },
    sheetCancel() {
      this.showSheetDialog = false;
    },
    gotoTms(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "tmsDetail",
        name: "tmsDetail",
        query: [
          {
            name: "HOId",
            value: id,
          },
        ],
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    getWayBillByPrimaryFileList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          PWB_Number: this.content.PWB_Number,
        };
        this.$api.logisticsManagement
          .getWayBillByPrimaryFileList(param)
          .then((res) => {
            this.fileList = res.data || [];
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    billConfirm() {
      this.showBillDialog = false;
      this.gotoPrint(1);
    },
    billCancel() {
      this.showBillDialog = false;
    },
    initWarehouse() {
      this.dialogSearchForm.warehouseNameOrNumber = "";
      this.dialogSearchForm.WarehouseOwnership = "";
      this.dialogSearchForm.WarehouseState = 1;
      this.dialogSearchForm.CountryId = null;
      this.dialogSearchForm.CountryName = "";
      this.dialogSearchForm.CityId = null;
      this.dialogSearchForm.CityName = "";
    },
    waybillGoodsWarehousing() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.dialogForm,
      };
      this.$api.logisticsManagement
        .waybillGoodsWarehousing(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showWarehouseDialog = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCountry(item) {
      this.dialogSearchForm.CountryName = item.text;
      this.dialogSearchForm.CountryId = item.value;
    },
    onSelectCity(item) {
      this.dialogSearchForm.CityName = item.text;
      this.dialogSearchForm.CityId = item.value;
    },
    pickerConfirm(e) {
      this.dialogForm.WarehouseName = e.text;
      this.dialogForm.WHId = e.value;
      this.showWarehousePicker = false;
    },
    pickerCancel() {
      this.showWarehousePicker = false;
    },
    warehouseCancel() {
      this.showWarehouseDialog = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    sheetSelect(e) {
      if (e.className == "1") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "billsReceivable",
          name: "billsReceivable",
          query: [
            {
              name: "WB_Number",
              value: this.content.WB_Number,
            },
          ],
        });
      }
      if (e.className == "2") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "supplierCostEntry",
          name: "supplierCostEntry",
          query: [
            {
              name: "PWB_Number",
              value: this.content.PWB_Number,
            },
            {
              name: "WB_Number",
              value: this.content.WB_Number,
            },
          ],
        });
      }
      if (e.className == "3") {
        this.dialogForm.WB_Id = this.content.WB_Id;
        this.getOptions().then((success) => {
          if (success) {
            this.showWarehouseDialog = true;
            this.sheetShow = false;
          }
        });
      }
      if (this.menuState == 1) {
        if (e.className == "4") {
          if (this.content.WB_Type == 2) {
            this.getWayBillShippingLabelPrintInfoByWB_Number().then((success) => {
              if (success) {
                this.showBillDialog = true;
              }
            });
          } else {
            this.gotoPrint(1);
          }
        }
        if (e.className == "5") {
          if (this.content.LogisticsChannel > 0) {
            this.showSheetDialog = true;
          } else {
            this.gotoPrint(2);
          }
        }
      }
      if (this.menuState == 2) {
        if (e.className == "4") {
          this.arrivalPrint();
        }
        if (e.className == "5") {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: true,
            path: "preAlert",
            name: "preAlert",
            query: [
              {
                name: "WB_Number",
                value: this.content.WB_Number,
              },
              {
                name: "Type",
                value: "arrival",
              },
            ],
          });
        }
      }
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.checkWaybill.sheet1, className: "1" },
        { name: this.$t.checkWaybill.sheet2, className: "2" },
        { name: this.$t.checkWaybill.sheet3, className: "3" },
      ];
      if (this.menuState == 1) {
        if (this.content.WB_Type != 5) {
          actions.push({ name: this.$t.checkWaybill.sheet4, className: "4" });
        }
        actions.push({ name: this.$t.checkWaybill.sheet5, className: "5" });
      }
      if (this.menuState == 2) {
        actions.push({ name: this.$t.checkWaybill.sheet4, className: "4" });
        actions.push({ name: this.$t.checkWaybill.sheet6, className: "5" });
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([
          this.getWarehouseManagementList(),
          this.getCountryList(),
          this.getCityList(),
        ]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getWayBillShippingLabelPrintInfoByWB_Number() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_Number: this.content.WB_Number,
        };
        this.$api.logisticsManagement
          .getWayBillShippingLabelPrintInfoByWB_Number(param)
          .then((res) => {
            this.dialogBillForm.IsShowLogo = res.data.IsShowLogo ? true : false;
            this.dialogBillForm.IsShowName = res.data.IsShowName ? true : false;
            this.dialogBillForm.IsDraft = res.data.IsDraft ? true : false;
            this.dialogBillForm.IsTelexRelease = res.data.IsTelexRelease ? true : false;
            this.dialogBillForm.IsOriginal = res.data.IsOriginal ? true : false;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoPrint(type) {
      var param = {
        WB_Number: this.content.WB_Number,
        OperationUserName: this.UserName,
        Type: type,
        FileType: 2,
        IsReturnBase64str: 1,
        IsShowLogo: this.dialogBillForm.IsShowLogo ? 1 : 0,
        IsShowName: this.dialogBillForm.IsShowName ? 1 : 0,
        IsDraft: this.dialogBillForm.IsDraft ? 1 : 0,
        IsTelexRelease: this.dialogBillForm.IsTelexRelease ? 1 : 0,
        IsOriginal: this.dialogBillForm.IsOriginal ? 1 : 0,
        IsPrintVtrackLabel: this.dialogSheetForm.IsPrintVtrackLabel,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createBarCodePdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    arrivalPrint() {
      var param = {
        WB_Number: this.content.WB_Number,
        IsShowLogo: 1,
        IsShowName: 1,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createBarCodePdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    getWarehouseManagementList() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.dialogSearchForm,
      };
      this.$api.storage
        .getWarehouseManagementList(param)
        .then((res) => {
          var result = [];
          res.data.Data.forEach((item) => {
            let data = {
              text: item.WarehouseName,
              value: item.WHId,
            };
            result.push(data);
          });
          this.warehouseList = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCountryList() {
      this.$api.customerManagement
        .getCountryList()
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CountryName + "," + item.CountryName_en,
              value: item.CountryId,
            };
            result.push(data);
          });
          this.countryList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCityList() {
      this.$api.logisticsManagement
        .getCountryList({
          type: 1,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.City_cn + "," + item.City_en,
              value: item.Id,
            };
            result.push(data);
          });
          this.cityList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.checkWaybillDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .avatarImg {
    width: 50px;
    height: 50px;
  }

  .sheet-alert {
    overflow: scroll;
    margin: 26px 16px 0px 0px;
    text-align: center;

    .van-radio-group {
      display: inline-block;
      margin: 0;

      .van-radio {
        margin-bottom: 26px;
      }
    }
  }

  .warehouse-radio {
    width: 90%;
    margin: auto;
    padding: 10px 0px;
    border-bottom: 1px solid #f4f4f4;

    .radio-label {
      color: #646566;
      margin-bottom: 10px;
      font-size: 14px;
    }

    .van-radio {
      margin-bottom: 10px;
      font-size: 14px;

      ::v-deep .van-radio__label {
        color: #646566;
      }
    }
  }

  .warehouse-checkbox {
    width: 80%;
    margin: auto;

    .van-checkbox {
      margin-bottom: 20px;
      font-size: 14px;

      ::v-deep .van-radio__label {
        color: #646566;
      }
    }
  }

  .bill-alert {
    overflow: scroll;
    margin-top: 20px;
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }

  .warehouse-dialog {
    top: 50% !important;

    .warehouse-alert {
      overflow: scroll;
      height: 120vw;
      margin-top: 30px;
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
